<button
    class="flex w-full gap-8 rounded hovered-layer pressed-layer p-8 text-left"
    type="button"
    [class.items-center]="!showDescription() || !agent().description"
    [class.items-start]="showDescription() && !!agent().description"
    (click)="agentClick.emit(agent())"
>
    @if (agent().avatar) {
        <img
            alt=""
            class="size-30 shrink-0 rounded-full object-cover"
            [src]="agent().avatar"
        />
    } @else {
        <div
            class="flex size-30 shrink-0 items-center justify-center rounded-full typo-sm-bold text-text-on-avatar"
            [class]="colorClass()"
        >
            {{ abbreviation() }}
        </div>
    }

    <div class="flex min-w-0 flex-col">
        <span class="line-clamp-1 typo-sm-bold">{{ agent().name }}</span>

        @if (showDescription() && agent().description) {
            <span class="typo-xs text-text-mid-contrast">{{
                agent().description
            }}</span>
        }
    </div>
</button>
